<template>
  <base-card>
    <h2>Schedules List</h2>
    <div>
      <ul>
        <li v-for="week in weeks" :key="week">
          <h3>Week {{ week }} (points = {{ weekGames(week)[0].points }})</h3>
          <ol>
            <li v-for="game in weekGames(week)" :key="game.gameId">
              <!-- Week {{ game.weekNumber }} Season Id: {{game.seasonId}}: -->
              <!-- {{ game.gameId }} -->
              <p>
                [GameId: {{ game.gameId }}] {{ game.visitor }} @ {{ game.home }}
              </p>
            </li>
          </ol>
        </li>
      </ul>
    </div>
    <base-button @click="saveSchedule">Save to DB</base-button>
  </base-card>
</template>

<script>
export default {
  computed: {
    currentSchedule() {
      return this.$store.getters["schedules/currentSchedule"];
    },
    weeks() {
      var weeks = [];
      var game;

      for (game of this.currentSchedule) {
        if (!weeks.includes(game.weekNumber)) {
          weeks.push(game.weekNumber);
        }
      }

      return weeks;
    },
  },
  methods: {
    weekGames(week) {
      return this.currentSchedule.filter((game) => {
        return game.weekNumber === week;
      });
    },
    saveSchedule() {
      this.$store.dispatch("schedules/saveSchedule", this.currentSchedule);
    },
  },
};
</script>